import { useState, useEffect } from 'react';
import { ReactComponent as ArrowUpIcon } from '../../../assets/arrow_up.svg';
import { ReactComponent as ArrowDownIcon } from '../../../assets/arrow_down.svg';

export const USER_FILTER_ALL = 'All users';

const UserFilter = ({
  selectedUser,
  setSelectedUser,
  users,
}: {
  selectedUser: string;
  setSelectedUser: (user: string) => void;
  users: string[];
}) => {
  const [listOpened, setListOpened] = useState(false);

  const updateFilter = (user: string) => {
    setSelectedUser(user);
    setListOpened(false);
  };

  return (
    <div
      tabIndex={1}
      onClick={() => setListOpened(true)}
      onBlur={() => setListOpened(false)}
      style={{
        ...{
          position: 'relative',
          width: '100%',
          display: 'flex',
          flexDirection: 'row' as 'row',
          alignItems: 'center',
        },
        ...styles.select,
      }}
    >
      {selectedUser}
      <div style={{ flex: 1 }}></div>
      {listOpened ? (
        <ArrowUpIcon style={{ width: '2.4vh', height: '2.4vh', color: 'rgba(16, 29, 59, 0.6)' }} />
      ) : (
        <ArrowDownIcon style={{ width: '2.4vh', height: '2.4vh', color: 'rgba(16, 29, 59, 0.6)' }} />
      )}

      {listOpened && (
        <div style={{ ...styles.dropdown }}>
          {[USER_FILTER_ALL, ...users.sort((a, b) => a.localeCompare(b))]
            .filter(user => user !== selectedUser)
            .map(user => (
              <div
                key={user}
                style={styles.option}
                onMouseDown={e => {
                  updateFilter(user);
                  e.stopPropagation();
                }} // Use onMouseDown to prevent blur before click
              >
                {user}
              </div>
            ))}
        </div>
      )}
    </div>
  );
};

const styles = {
  select: {
    padding: '1.2vh',
    borderRadius: '1.6vh',
    border: '0.1vh solid rgba(16, 29, 59, 0.1)',
    backgroundColor: '#ffffff',
    color: '#101D3B',
    cursor: 'pointer',
    transition: 'border-color 0.2s',
    outline: 'none',
    width: '44.4vh',
    boxSizing: 'border-box' as 'border-box',
    fontWeight: '400',
    fontSize: '1.4vh',
  },
  dropdown: {
    position: 'absolute' as 'absolute',
    padding: '0vh 1.6vh',
    top: 'calc(100% - 0.6vh)', // Position it right below the input
    left: '0',
    width: 'calc(100% - 3.2vh)', //compensate padding
    borderTop: 'none',
    maxHeight: '15vh',
    overflowY: 'auto' as 'auto',
    backgroundColor: '#ffffff',
    zIndex: 1,
    borderRadius: '1.6vh',
    boxShadow: '0vh 0.8vh 3.2vh -0.4vh rgba(16, 29, 59, 0.1)',
  },
  option: {
    padding: '0.8vh 0vh',
    fontWeight: '400',
    fontSize: '1.4vh',
    cursor: 'pointer',
    borderBottom: '0.1vh solid #eee',
    color: '#2d3436',
    textAlign: 'left' as 'left',
    height: '3.2vh',
    display: 'flex',
    alignItems: 'center',
  },
};

export default UserFilter;
